import React from "react";

/* ============================================================================
 * HomeLifestyle — กล่อง "ค้นหาตามไลฟ์สไตล์" (คอลัมน์ขวาของแถวโครงการ)
 *
 * ทางลัดค้นหาด้วยเงื่อนไขการใช้ชีวิต (ใกล้รถไฟฟ้า / เลี้ยงสัตว์ได้ / ...)
 * สำหรับคนที่ยังไม่มีทำเลหรือประเภททรัพย์ในใจ
 * รายการ/ไอคอน/ลำดับ แก้ไขได้จากหลังบ้าน (/ad/home/shortcuts)
 *
 * ใช้หัวข้อขนาดเดียวกับคอลัมน์โครงการด้านซ้าย และปล่อยให้กริดยืดเต็มความสูง
 * ที่เหลือ — หัวและท้ายของสองคอลัมน์จะได้ตรงกันพอดีเป็นบล็อกเดียว
 * ========================================================================== */
export default function HomeLifestyle({ data, onSelect }) {
  const items = data?.items || [];
  if (!items.length) return null;

  return (
    <aside className="hm-split__side">
      <div className="hm-section__head">
        <h2 className="hm-section__title">{data?.section?.title || ""}</h2>
      </div>

      <div className="hm-lifes">
        {items.map((item) => (
          <button key={item.uid} type="button" className="hm-life" onClick={() => onSelect && onSelect(item)}>
            <span className="hm-life__icon hm-ico">{item.icon}</span>
            <span className="hm-life__label">{item.label}</span>
          </button>
        ))}
      </div>
    </aside>
  );
}
